module.exports = __webpack_public_path__ + "static/media/img_service.87542e37.png";